import { default as TallExhibitionist } from './TallExhibitionistBox';
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import TallExhibitionist__premium_folders from '../TallExhibitionist__premium_folders';

export default withFeatureBranch({
  premium_folders: TallExhibitionist__premium_folders,
})(TallExhibitionist);
